import { IdCard, Gift, UserRound } from "lucide-react";

// Default display mode for each member section; a member's saved choice overrides these
export const DEFAULT_PORTAL_VIEW = {
  membership: "expanded",
  referral: "icon",
  profile: "icon",
};

export const MEMBER_SECTIONS = {
  membership: { label: "Membership", icon: IdCard },
  referral: { label: "Refer & Earn", icon: Gift },
  profile: { label: "Profile", icon: UserRound },
};

export const resolvePortalView = (saved) => {
  const out = { ...DEFAULT_PORTAL_VIEW };
  Object.keys(out).forEach((k) => { if (saved?.[k] === "expanded" || saved?.[k] === "icon") out[k] = saved[k]; });
  return out;
};
